module.exports = __webpack_public_path__ + "static/media/placeholderimage.d3e5b127.png";